import { useContext, useState } from 'react'

import AppContext from '@/context/AppContext'

const useRegionModal = () => {
  const { context, setContext } = useContext(AppContext)
  const [showRegionModal, setShowRegionModal] = useState(false)
  const currentCountry = context.orderInfo.shipping_address?.country

  const isShippingAddressProvinceInProvinces = provinces => {
    return provinces?.some(province => province.id === context.orderInfo.shipping_address?.province?.id)
  }

  const shouldShowRegionModal = provinces => {
    return provinces?.length > 0 && !isShippingAddressProvinceInProvinces(provinces)
  }

  const getProvinces = () => {
    return context?.allowed_region?.provinces?.map(p => ({ label: p.name, value: p.id }))
  }

  const onChangeRegion = (provinceId, cb) => {
    const newProvince = context?.allowed_region?.provinces?.find(p => p.id === provinceId)

    setContext(context => ({
      ...context,
      orderInfo: {
        ...context.orderInfo,
        shipping_address: {
          ...context.orderInfo.shipping_address,
          province: newProvince,
        },
      },
    }))

    setShowRegionModal(false)

    if (cb && typeof cb === 'function') cb(newProvince)
  }

  return { showRegionModal, setShowRegionModal, shouldShowRegionModal, getProvinces, currentCountry, onChangeRegion }
}

export default useRegionModal
